/**
 * Inlined gradient-simple faces as data URLs.
 * Same graphics as assets/fbs/ratings/gradient-simple/*.svg, served through
 * <img src> so layout matches production (no inline <svg> / CSS changes).
 * Hash-file <img> srcs refetch after remount and break offline.
 */
const svgDataUrl = (markup) =>
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(markup.trim())}`;

export const gradientSimple1 = svgDataUrl(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
  <defs>
    <linearGradient id="faceGrad" x1="50%" y1="100%" x2="50%" y2="0%">
      <stop offset="0%" stop-color="#dd1f2d"/>
      <stop offset="100%" stop-color="#f45f59"/>
    </linearGradient>
  </defs>
  <circle cx="100" cy="100" r="90" fill="url(#faceGrad)"/>
  <path d="M46 70C56 64 69 65 80 79" stroke="#231F20" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M154 70C144 64 131 65 120 79" stroke="#231F20" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <ellipse cx="62" cy="98" rx="12" ry="19" fill="#231F20"/>
  <ellipse cx="138" cy="98" rx="12" ry="19" fill="#231F20"/>
  <path d="M49 151C62 134 80 125 100 125C120 125 138 134 151 151" stroke="#231F20" stroke-width="10" stroke-linecap="round" fill="none"/>
</svg>
`);

export const gradientSimple2 = svgDataUrl(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
  <defs>
    <linearGradient id="faceGrad" x1="50%" y1="100%" x2="50%" y2="0%">
      <stop offset="0%" stop-color="#f97218"/>
      <stop offset="100%" stop-color="#ffab2e"/>
    </linearGradient>
  </defs>
  <circle cx="100" cy="100" r="90" fill="url(#faceGrad)"/>
  <ellipse cx="66" cy="88" rx="11" ry="18" fill="#231F20"/>
  <ellipse cx="134" cy="88" rx="11" ry="18" fill="#231F20"/>
  <path d="M53 143C64 126 81 117 100 117C119 117 136 126 147 143" stroke="#231F20" stroke-width="9" stroke-linecap="round" fill="none"/>
</svg>
`);

export const gradientSimple3 = svgDataUrl(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
  <defs>
    <linearGradient id="faceGrad" x1="50%" y1="100%" x2="50%" y2="0%">
      <stop offset="0%" stop-color="#f9be23"/>
      <stop offset="100%" stop-color="#ffe14b"/>
    </linearGradient>
  </defs>
  <circle cx="100" cy="100" r="90" fill="url(#faceGrad)"/>
  <ellipse cx="66" cy="90" rx="11" ry="18" fill="#231F20"/>
  <ellipse cx="134" cy="90" rx="11" ry="18" fill="#231F20"/>
  <path d="M55 134H145" stroke="#231F20" stroke-width="9" stroke-linecap="round" fill="none"/>
</svg>
`);

export const gradientSimple4 = svgDataUrl(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
  <defs>
    <linearGradient id="faceGrad" x1="50%" y1="100%" x2="50%" y2="0%">
      <stop offset="0%" stop-color="#00aeb7"/>
      <stop offset="100%" stop-color="#6cc9c6"/>
    </linearGradient>
  </defs>
  <circle cx="100" cy="100" r="90" fill="url(#faceGrad)"/>
  <ellipse cx="66" cy="88" rx="11" ry="18" fill="#231F20"/>
  <ellipse cx="134" cy="88" rx="11" ry="18" fill="#231F20"/>
  <path d="M50 125C62 142 80 151 100 151C120 151 138 142 150 125" stroke="#231F20" stroke-width="9" stroke-linecap="round" fill="none"/>
</svg>
`);

export const gradientSimple5 = svgDataUrl(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
  <defs>
    <linearGradient id="faceGrad" x1="50%" y1="100%" x2="50%" y2="0%">
      <stop offset="0%" stop-color="#44c85a"/>
      <stop offset="100%" stop-color="#95d13c"/>
    </linearGradient>
  </defs>
  <circle cx="100" cy="100" r="90" fill="url(#faceGrad)"/>
  <path d="M49 86C49 76.6112 56.6112 69 66 69C75.3888 69 83 76.6112 83 86" stroke="#231F20" stroke-width="9" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M117 86C117 76.6112 124.611 69 134 69C143.389 69 151 76.6112 151 86" stroke="#231F20" stroke-width="9" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <path d="M54 111H146C146 136.405 125.405 157 100 157C74.5949 157 54 136.405 54 111Z" fill="#231F20"/>
</svg>
`);
